module.exports = __webpack_public_path__ + "img/Wp_2013.ba677b7f.png";